import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material";
import { theme } from "./utils/styles";
import { BrowserRouter } from "react-router-dom";
import { store } from "./utils/store";
import { Provider } from "react-redux";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import { StepperProvider } from "./screens/BulkUpload/components/exportLead/StepperContext";

/** CRA overlay shows "[object Object]" for plain object throws/rejections — silence those */
const silenceObjectRuntimeErrors = () => {
  const onRejection = (event: PromiseRejectionEvent) => {
    const reason = event.reason;
    if (reason instanceof Error) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    console.error(
      "[api]",
      typeof reason?.message === "string"
        ? reason.message
        : typeof reason === "string"
          ? reason
          : "Request failed",
      reason
    );
  };

  const onError = (event: ErrorEvent) => {
    if (event.error instanceof Error) return;
    if (event.error && typeof event.error === "object") {
      event.preventDefault();
      event.stopImmediatePropagation();
      console.error("[api]", event.message || event.error);
    }
  };

  window.addEventListener("unhandledrejection", onRejection, true);
  window.addEventListener("error", onError, true);

  // Best-effort: stop CRA runtime error overlay if available
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const ErrorOverlay = require("react-error-overlay");
    if (ErrorOverlay?.stopReportingRuntimeErrors) {
      ErrorOverlay.stopReportingRuntimeErrors();
    }
  } catch {
    // ignore
  }
};

silenceObjectRuntimeErrors();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <StepperProvider>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <React.StrictMode>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </React.StrictMode>
      </Provider>
    </ThemeProvider>
  </StepperProvider>
);
reportWebVitals();
